<template>
  <div class="t1">
    <nav_list :index="4"></nav_list>


    <div v-if="info.id > 0">
      <div class="shop_info bg">
            <el-page-header @back="jump('/shop')" class="headpge" :content="info.strs.title">
            </el-page-header>
        <div class="top">
          <div class="banner">
            <el-carousel :interval="5000" arrow="always">
              <el-carousel-item v-for="(src, i)  in info.strs.banners" :key="i">
                <img :src="src" alt="">
              </el-carousel-item>
            </el-carousel>
          </div>
          <div class="info">
            <div class="tit">
              {{info.strs.title}}
            </div>

            <div class="desc">
              <div class="l1">
                <div class="drow">
                  <span class="drl"> <i class="el-icon-add-location"></i> {{ $lang(70380) }} :</span>
                  <span> <el-tag type="success">
                      {{ info.strs.city }}

                    </el-tag>

                  </span>
                </div>
                <div class="drow">
                  <span class="drl"> <i class="el-icon-location-information"></i>  {{ $lang(70381) }} :</span>
                  <span> {{ info.address }}</span>
                </div>
                <div class="drow">
                  <span class="drl"> <i class="el-icon-position"></i>  {{ $lang(70385) }} :</span>
                  <span> {{ info.route }}</span>
                </div>
                <div class="drow">
                  <span class="drl"> <i class="el-icon-time"></i> {{ $lang(70382) }} :</span>
                  <span> {{ info.open_time }}</span>
                </div>



                  <div class="drow">
                    <span class="drl"> <i class="el-icon-phone-outline"></i> {{ $lang(42667) }} :</span>
                    <span> {{ info.tel }}</span>
                  </div>
                  <div class="drow">
                    <span class="drl"> <i class="el-icon-wallet"></i> {{ $lang(70384) }} :</span>
                    <span  v-for="pi in pays" :key="pi">
                    <el-tag type=" ">
                      {{ ps[pi].strs.title }}

                    </el-tag> &nbsp;  </span>
                  </div>

                        <div class="drow">
                          <el-tag type="warning">
                            {{ ps[info.china_cate_id].strs.title }}

                          </el-tag>
                          &nbsp;
                          <el-tag type="warning">
                            {{ ps[info.china_tag_id].strs.title }}

                          </el-tag>
                        </div>
              </div>


            </div>

          </div>
        </div>

        <el-divider><i class="el-icon-info"></i></el-divider>

        <div class="cont" v-html="info[cache('lang_config')]">

        </div>
      </div>

    </div>

    <div style=" text-align: center;">
      <el-button class="btnz" @click="jump('/')">{{ $lang(51494) }} </el-button>
    </div>
  </div>
</template>

<script>


import nav_list from '../index/nav_list.vue';
export default {
  name: "bus_list",

  components: {
    nav_list,
  },

  data() {
    return {

      ps : {},
      pays:[],
      info: {
        id: 0,
      },
      id: 1,

    };
  },
  mounted(e) {
    if (!this.$route.query.id) {
      return this.jump('/')
    }
    this.id = this.$route.query.id
    this.f5()
  },

  methods: {

    f5() {
      this.get("/shop/info", { id: this.id },).then((e) => {

        this.info = e.info
        this.pays = this.info.pay_types.split(',')
        this.ps = e.ps

      });
    },

  }
}
</script>

<style scoped >
.shop_info {
  width: 85vw;
  margin: auto;
  padding: 20px;
}
.headpge {
  margin-left: 20px;
}
.shop_info .top {
  display: flex;
  padding: 20px;

  margin-top: 20px;
}
.banner {
  flex: 0 0 50%;
}

.banner img {
  width: 100%;
}

.info {
  padding-left: 5%;
}
.bg .info .desc {
  flex: 0 0 50%;

  display: flex;
  justify-content: space-between;
  font-size: 14px;
  align-items: center;
}

.bg .info .desc .drl {
  color: #6d6d6d;
  margin-right: 10px;
}

.bg .info .desc .drow {
  margin-top: 10px;
}

.cont {
  padding: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/shop/info.vue